var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.headerActionConfig,
          "left-side-class": "col-xl-4 pb-2",
          page: _vm.headerConfig,
          "right-side-class":
            "col-xl-8 align-items-end d-flex pb-4 justify-content-end"
        }
      }),
      _c("filter-manager", {
        ref: "rubricFilterRef",
        attrs: { "display-advanced": false, filters: _vm.filterConfig },
        on: {
          search: function($event) {
            return _vm.search()
          }
        },
        model: {
          value: _vm.filter.model,
          callback: function($$v) {
            _vm.$set(_vm.filter, "model", $$v)
          },
          expression: "filter.model"
        }
      }),
      _c("custom-separator", {
        staticClass: "pt-3 my-4",
        attrs: { text: "Resultados" }
      }),
      _vm.pagination.data.length === 0
        ? _c("custom-result-not-found", {
            attrs: { text: "No Hay Información Disponible" }
          })
        : _vm._e(),
      _vm._l(_vm.pagination.data, function(row) {
        return _c(
          "div",
          { key: row.id },
          [
            _c("result-row", {
              attrs: { data: row },
              on: { refresh: _vm.search }
            })
          ],
          1
        )
      }),
      _vm.showPagination
        ? _c("pagination", {
            attrs: { data: _vm.pagination, "show-text": "" },
            on: { "pagination-go-page": _vm.goToPage }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }